import { defineStore } from 'pinia';
import { documentTypeApiService } from 'src/services';
import docTypeLable from 'src/utils/docTypeLable';

export const useDocumentTypeFiltersStore = defineStore(
  'document_type_filter_store',
  {
    state: () => ({
      document_type_filter: [] as any,
      document_type_filter_loading: false,
    }),
    actions: {
      async getDocumentTypeFilters() {
        try {
          this.document_type_filter_loading = true;
          this.document_type_filter = [];

          const response = await documentTypeApiService.fetchTypeFilters();

          if (!response) {
            throw response;
          }

          response.data.forEach((docObj: any, index: any) => {
            docObj['type'] = docObj.document_key;
            const docTypeLabel = docTypeLable.methods.getDocTypeLabel(docObj);

            const parent_type = Object.assign(
              {},
              {
                value: docObj.document_key,
                name: docObj.document_name
                  ? docObj.document_name
                  : docObj.document_key,
                label: docTypeLabel,
                translation_key: docObj.translation_key
                  ? docObj.translation_key
                  : docObj.document_key,
                title: docObj.title,
              },
            );

            this.document_type_filter.push(parent_type);
          });

          this.sortList();
        } catch (err) {
          logError(err);
        } finally {
          this.document_type_filter_loading = false;
        }
      },

      sortList() {
        this.document_type_filter.sort(function (a: any, b: any) {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        });
      },
    },
  },
);
